<div class="recover-password-bdp content-without-footer d-flex">
    <app-sprintpay-password-recovery
        class="position-absolute"
        [widthLogo]="'156'"
        [heightLogo]="'26'"
    ></app-sprintpay-password-recovery>
</div>
